import createIcon from '../../createIcon';

/**
 * @component @name Piano
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgM0g1QzMuOSAzIDMgMy45IDMgNVYxOUMzIDIwLjEgMy45IDIxIDUgMjFIMTlDMjAuMSAyMSAyMSAyMC4xIDIxIDE5VjVDMjEgMy45IDIwLjEgMyAxOSAzWk0xNCAxNC41SDE0LjI1VjE5SDkuNzVWMTQuNUgxMEMxMC41NSAxNC41IDExIDE0LjA1IDExIDEzLjVWNUgxM1YxMy41QzEzIDE0LjA1IDEzLjQ1IDE0LjUgMTQgMTQuNVpNNSA1SDdWMTMuNUM3IDE0LjA1IDcuNDUgMTQuNSA4IDE0LjVIOC4yNVYxOUg1VjVaTTE5IDE5SDE1Ljc1VjE0LjVIMTZDMTYuNTUgMTQuNSAxNyAxNC4wNSAxNyAxMy41VjVIMTlWMTlaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Piano = createIcon('Piano', [
  [
    'path',
    {
      d: 'M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM14 14.5H14.25V19H9.75V14.5H10C10.55 14.5 11 14.05 11 13.5V5H13V13.5C13 14.05 13.45 14.5 14 14.5ZM5 5H7V13.5C7 14.05 7.45 14.5 8 14.5H8.25V19H5V5ZM19 19H15.75V14.5H16C16.55 14.5 17 14.05 17 13.5V5H19V19Z',
      key: 'hrd39o',
    },
  ],
]);

export default Piano;
